module.exports = __webpack_public_path__ + "media/images/favicons/57x57-76b5924ab4e1f1ed91b449e3d556266b.png";